import getSpacedChildren from './getSpacedChildren';
import getAbsoluteChildren from './getAbsoluteChildren';
import getAttachedChildren from './getAttachedChildren';
import { addTextAndPropsToStrings } from './addTextAndPropsToStrings';
import { canUseDom } from './canUseDom';
import { mergeRefs } from './mergeRefs';
export {
  getSpacedChildren,
  getAbsoluteChildren,
  getAttachedChildren,
  addTextAndPropsToStrings,
  canUseDom,
  mergeRefs,
};

export type { IAccessibilityProps } from './accessibilityTypes';
